import { Component, Renderer2 } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { ToastrService } from 'ngx-toastr';
import { SendNotification } from '../ag-grid.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonPopupComponent } from 'src/app/shared/common-popup/common-popup.component';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-pdf-icon-renderer',
  templateUrl: './pdf-icon-renderer.component.html',
  styleUrls: ['./pdf-icon-renderer.component.scss']
})
export class PdfIconRendererComponent extends CommonService{
  public params: ICellRendererParams ;
  sendNotifications = new SendNotification()

  constructor(   
    public agGridService: AgGridService,
    public toaster: ToastrService,
    private modalService : NgbModal,
    private rendere : Renderer2
    ){
      super(rendere)
  }

  agInit(params: ICellRendererParams ): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }


  handlePrintClick(params): void {
    const customEvent = new CustomEvent('printButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customEvent);
  }
  clickOnPdfIcon(params){
    console.log( params);
    const selectedData = { data: [params?.data?.id], notificationTypeId: 3 };
    this.sendNotification(selectedData)

  }
  sendNotification(selectedData){
    if(this.params.data.contactNo !== ''){
    this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
    this.sendNotifications.id  = selectedData.data;
    this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
      console.log(res);
      if (res.isSuccess) {
        this.base64ToPdfAndPrint(res.response)
      }else{
        this.toaster.error(res.message)
  
      }
    })
  }else{
    this.toaster.error("PDF not available")
  }
  }

}